import React from 'react';
import styled from 'styled-components';

import { PROGRESS_STATUS_DONE, PROGRESS_STATUS_IN_PROGRESS } from '@src/const/course';
import { IProgressList } from '@src/types/course';

import ProgressCircle from './progressCircle';
import ProgressLine from './progressLine';

const ProgressBarWrapper = styled.div`
	height: 168px;
`;

const ProgressResult = styled.div`
	position: relative;
	top: -32px;
	margin: 12px 0 0 24px;
`;

interface IProgressBar {
	progressList: IProgressList[];
	children?: JSX.Element;
}

const ProgressBar = ({ progressList, children }: IProgressBar): JSX.Element => (
	<ProgressBarWrapper>
		{progressList.map((progress, index) => {
			const isLast = index === (progressList.length - 1);

			return (
				<div className="progress-bar" key={`progress-${progress.text}`}>
					<ProgressCircle index={index} isLast={isLast} status={progress.status} text={progress.text} />
					{!isLast && (
						<ProgressLine index={index} status={progress.status}>
							{(progress.status === PROGRESS_STATUS_IN_PROGRESS) && children}
						</ProgressLine>
					)}
					{isLast && (progress.status === PROGRESS_STATUS_DONE) && (
						<ProgressResult>{children}</ProgressResult>
					)}
				</div>
			);
		})}
	</ProgressBarWrapper>
);

export default ProgressBar;
